import * as React from 'react';

const MoreIcon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
  >
    <rect
      x="1.1365e-06"
      y="26"
      width="26"
      height="26"
      rx="8"
      transform="rotate(-90 1.1365e-06 26)"
      fill="#FFFFFF1A"
    />
    <path
      d="M12.25 13C12.25 12.5858 12.5858 12.25 13 12.25C13.4142 12.25 13.75 12.5858 13.75 13C13.75 13.4142 13.4142 13.75 13 13.75C12.5858 13.75 12.25 13.4142 12.25 13Z"
      stroke="#fff"
      strokeWidth="1.5"
    />
    <path
      d="M18 13C18 12.5858 18.3358 12.25 18.75 12.25C19.1642 12.25 19.5 12.5858 19.5 13C19.5 13.4142 19.1642 13.75 18.75 13.75C18.3358 13.75 18 13.4142 18 13Z"
      stroke="#fff"
      strokeWidth="1.5"
    />
    <path
      d="M6.5 13C6.5 12.5858 6.83579 12.25 7.25 12.25C7.66421 12.25 8 12.5858 8 13C8 13.4142 7.66421 13.75 7.25 13.75C6.83579 13.75 6.5 13.4142 6.5 13Z"
      stroke="#fff"
      strokeWidth="1.5"
    />
  </svg>
);

export default MoreIcon;
